const LocationViewModel = Backbone.Model.extend({
  defaults: {
    "errorMessage":"",
    "locationID": 0,
    "locationName":"",
    "locationDesc":"",
    "locationImgURL":"",
    "locationEmail":"",
    "locationPhone":"",
    "officeHours":"",
    "galleryHours":"",
    "locationTypeID": 0,
    "displayOrder": 0,
    "isDisplay": false,
    "isRegional": false,
    "isActive": false,
    "locationAddressView": {} //new phillips.LocationAddressModel()
  },
  initialize: function() {
    //var locAddView = null;
    //if (this.get("locationAddressView") !== null) {
    //	locAddView = new phillips.LocationAddressModel(this.get("locationAddressView"));
    //}
    //this.set("locationAddressView", locAddView);
  }
});

export default LocationViewModel;
